import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import messageTemplatesApi from '@/features/dashboard/messageTemplates/api/messageTemplatesApi.ts';

const useSendTestSms = () => {
  return useMutation({
    mutationFn: ({
      type,
      bodyTemplate,
      phoneNumber,
    }: {
      type: string;
      bodyTemplate: string;
      phoneNumber: string;
    }) => messageTemplatesApi.sendTestSms(type, { bodyTemplate, phoneNumber }),
    onSuccess: () => {
      toast.success('Testowy SMS został wysłany');
    },
    onError: (error: Error) => {
      toast.error('Nie udało się wysłać testowego SMS-a', {
        description: error.message,
      });
    },
  });
};

export default useSendTestSms;
